import { render, staticRenderFns } from "./flightCosts.vue?vue&type=template&id=32190818&scoped=true&"
import script from "./flightCosts.vue?vue&type=script&lang=js&"
export * from "./flightCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32190818",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32190818')) {
      api.createRecord('32190818', component.options)
    } else {
      api.reload('32190818', component.options)
    }
    module.hot.accept("./flightCosts.vue?vue&type=template&id=32190818&scoped=true&", function () {
      api.rerender('32190818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/airConfig/flightList/flightCosts.vue"
export default component.exports